import { USER_TYPES } from '../../models/User';

class UserSerializer {
  static getUserType(data) {
    if (data.Cliente.CliTipo === 2) {
      return USER_TYPES.COMPANY;
    }
    if (data.CWeRUT) {
      return USER_TYPES.UNIPERSONAL;
    }
    return USER_TYPES.PERSON;
  }

  static deSerialize(data) {
    const userType = UserSerializer.getUserType(data);
    const baseData = {
      id: data.CWeId,
      email: data.CWeMail,
      type: userType,
      state: data.CWeEstado,
      showCredit: data.CWeHistoriaCreditosWeb,
      canNoPayWithBank: data.CWeNoPagaConBanco,
    };
    if (userType === USER_TYPES.COMPANY) {
      return {
        ...baseData,
        fictitiousName: data.CWeApellidos,
        rut: data.Cliente.CliCiRuc,
        tradeName: data.CWeNombres,
      };
    }
    return {
      ...baseData,
      names: data.CWeNombres,
      surnames: data.CWeApellidos,
      documentCountry: data.Cliente.CliPaisDelDocumento,
      document: data.Cliente.CliCiRuc,
      rut: data.CWeRUT,
    };
  }
}

export { UserSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/UserSerializer.js